import React from 'react';
import { WAREHOUSE_ROUTES } from '../../../../constants/routes';
import { UserIconANT } from '../../../common/icons/sideBarIcons/UserIcon';
import { WarehouseOperationsIcon } from '../../../common/icons/warehouse/WarehouseOperationsIcon';

export interface MenuItem {
  key: string;
  label: any;
  icon?: React.ReactNode;
  path?: string;
  children?: MenuItem[];
}

export const MenuItemLabel = ({ children }: { children: React.ReactNode }) => {
  return <span style={{ display: 'inline-block', paddingLeft: 8 }}>{children}</span>;
};

export const warehouseMenuItems: MenuItem[] = [
  {
    key: 'operations',
    label: 'Warehouse Operations',
    icon: <WarehouseOperationsIcon />,
    children: [
      {
        key: 'inbound-packages',
        label: <MenuItemLabel>Inbound Packages</MenuItemLabel>,
        path: WAREHOUSE_ROUTES.inboundPackages,
      },
      {
        key: 'outbound-packages',
        label: <MenuItemLabel>Outbound Packages</MenuItemLabel>,
        path: WAREHOUSE_ROUTES.outboundPackages,
      },
    ],
  },
  {
    key: 'profile',
    label: 'Profile',
    icon: <UserIconANT />,
    path: WAREHOUSE_ROUTES.warehouseProfile,
  },
];

export const findMenuItem = (items: MenuItem[], key: string): MenuItem | null => {
  for (const item of items) {
    if (item.key === key) return item;
    if (item.children) {
      const found = findMenuItem(item.children, key);
      if (found) return found;
    }
  }
  return null;
};

export const buildMenuItems = (items: MenuItem[]): any => {
  return items.map((item) => ({
    key: item.key,
    icon: item.icon,
    label: item.label,
    children: item.children ? buildMenuItems(item.children) : undefined,
  }));
};
